import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Grid } from '@mui/material';

import { Language } from '@nx-smartmonkey/shared/domain';
import { getMonth } from '@nx-smartmonkey/shared/helpers';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import moment from 'moment';
import { useRetrieveActiveLanguage } from '../../../hooks/translations/useRetrieveActiveLanguage';
import { Text } from '../../../react-components/Text';
import { useAnalyticsFilters } from './hooks/useAnalyticsFilters';

export const AnalyticsDateRangeContainer = () => {
  const { activeLanguage } = useRetrieveActiveLanguage();
  const { binType, startDate, endDate, setStartDate } = useAnalyticsFilters();

  const language = activeLanguage ?? Language.getDefaultLanguage().value;

  const onNavigate = (goForward: boolean) => {
    if (binType === `day`) {
      const startLocaleMoment = moment(startDate).locale(language);
      if (goForward) {
        startLocaleMoment.add(7, `days`);
      } else {
        startLocaleMoment.subtract(7, `days`);
      }
      setStartDate(new Date(startLocaleMoment.startOf(`week`).toDate()));
    } else if (binType === `week`) {
      const startLocaleMoment = moment(startDate).locale(language);
      if (goForward) {
        startLocaleMoment.add(1, `month`);
      } else {
        startLocaleMoment.subtract(1, `month`);
      }
      setStartDate(new Date(startLocaleMoment.startOf(`month`).toDate()));
    }
  };

  const getVisibleDate = () => {
    if (binType === `day`) {
      const startLocaleMoment = moment(startDate).locale(language);
      const endLocaleMoment = moment(endDate).locale(language);
      return `${startLocaleMoment.format(`L`)} - ${endLocaleMoment.format(`L`)}`;
    }
    if (binType === `week`) {
      const month = getMonth({
        date: startDate,
        language,
        large: true,
      });
      return month.charAt(0).toUpperCase() + month.slice(1);
    }
    return null;
  };

  return (
    <Grid container direction="row" style={{ padding: `12px 0` }} wrap="nowrap">
      <ArrowBackIosNewIcon onClick={() => onNavigate(false)} style={{ color: RoutalPalette.neutral20 }} />

      <Text style={{ color: RoutalPalette.neutral20, width: `100%`, textAlign: `center` }}>{getVisibleDate()}</Text>

      <ArrowForwardIosIcon onClick={() => onNavigate(true)} style={{ color: RoutalPalette.neutral20 }} />
    </Grid>
  );
};
